import { SvelteComponent, init, safe_not_equal, create_component, mount_component, transition_in, transition_out, destroy_component, onDestroy, space, insert, detach, text, noop, element, attr, src_url_equal, append, set_data, is_function } from '../../external_node_modules/svelte/internal/index.mjs.js';
import { t } from '../../i18n.js';
import Popup from '../shared/components/Popup/Popup.svelte.js';
import PopupHeader from '../shared/components/Popup/PopupHeader.svelte.js';
import PopupBody from '../shared/components/Popup/PopupBody.svelte.js';
import PopupFooter from '../shared/components/Popup/PopupFooter.svelte.js';
import Button from '../shared/components/Button/Button.svelte.js';
import Notice from '../shared/components/Notice/Notice.svelte.js';
import Checkbox from '../shared/components/Checkbox/Checkbox.svelte.js';
import localStorageHelper from '../../utils/localStorage.js';
import { updateBrowserControlState } from '../../external_node_modules/@wg/web2clientapi/browser/updateBrowserControlState.js';
import './App.css.js';

/* src/ui/LootboxRestriction/App.svelte generated by Svelte v3.44.2 */

function create_default_slot_6(ctx) {
	let t_1_value = t('Подтверждение покупки') + "";
	let t_1;

	return {
		c() {
			t_1 = text(t_1_value);
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

// (49:10) <Notice>
function create_default_slot_5(ctx) {
	let t_1_value = t('Открытие контейнера не гарантирует получение конкретных внутриигровых предметов — с определённой вероятностью вы можете получить любую награду из списка. Вы всегда получаете содержимое стоимостью не менее затраченной на покупку суммы. Пожалуйста, внимательно следите за своими расходами, совершая покупки в игре.') + "";
	let t_1;

	return {
		c() {
			t_1 = text(t_1_value);
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

// (60:10) <Checkbox checked="{isChecked}" onChange="{onChange}">
function create_default_slot_4(ctx) {
	let t_1_value = t('Я подтверждаю, что мне исполнилось 18 лет') + "";
	let t_1;

	return {
		c() {
			t_1 = text(t_1_value);
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

// (43:2) <PopupBody>
function create_default_slot_3(ctx) {
	let div9;
	let div7;
	let div0;
	let t0_value = /*product*/ ctx[2].title + "";
	let t0;
	let t1;
	let div1;
	let t3;
	let div2;
	let notice;
	let t4;
	let div5;
	let div3;
	let t6;
	let div4;
	let raw_value = /*product*/ ctx[2].formattedPrice + "";
	let t7;
	let div6;
	let checkbox;
	let t8;
	let div8;
	let img;
	let img_src_value;
	let img_alt_value;
	let current;

	notice = new Notice({
			props: {
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	checkbox = new Checkbox({
			props: {
				checked: /*isChecked*/ ctx[3],
				onChange: /*onChange*/ ctx[4],
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			div9 = element("div");
			div7 = element("div");
			div0 = element("div");
			t0 = text(t0_value);
			t1 = space();
			div1 = element("div");
			div1.textContent = `${t('Контейнер')}`;
			t3 = space();
			div2 = element("div");
			create_component(notice.$$.fragment);
			t4 = space();
			div5 = element("div");
			div3 = element("div");
			div3.textContent = `${t('Стоимость:')}`;
			t6 = space();
			div4 = element("div");
			t7 = space();
			div6 = element("div");
			create_component(checkbox.$$.fragment);
			t8 = space();
			div8 = element("div");
			img = element("img");
			attr(div0, "class", "product-title wcl-17upa2d");
			attr(div1, "class", "product-type wcl-17upa2d");
			attr(div2, "class", "product-notice wcl-17upa2d");
			attr(div3, "class", "product-price-title wcl-17upa2d");
			attr(div4, "class", "product-price wcl-17upa2d");
			attr(div5, "class", "product-price-info wcl-17upa2d");
			attr(div6, "class", "age-restriction wcl-17upa2d");
			attr(div7, "class", "product wcl-17upa2d");
			if (!src_url_equal(img.src, img_src_value = /*product*/ ctx[2].tileImageUrl)) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = /*product*/ ctx[2].title);
			attr(img, "class", "wcl-17upa2d");
			attr(div8, "class", "preview-image wcl-17upa2d");
			attr(div9, "class", "content wcl-17upa2d");
		},
		m(target, anchor) {
			insert(target, div9, anchor);
			append(div9, div7);
			append(div7, div0);
			append(div0, t0);
			append(div7, t1);
			append(div7, div1);
			append(div7, t3);
			append(div7, div2);
			mount_component(notice, div2, null);
			append(div7, t4);
			append(div7, div5);
			append(div5, div3);
			append(div5, t6);
			append(div5, div4);
			div4.innerHTML = raw_value;
			append(div7, t7);
			append(div7, div6);
			mount_component(checkbox, div6, null);
			append(div9, t8);
			append(div9, div8);
			append(div8, img);
			current = true;
		},
		p(ctx, dirty) {
			if ((!current || dirty & /*product*/ 4) && t0_value !== (t0_value = /*product*/ ctx[2].title + "")) set_data(t0, t0_value);
			const notice_changes = {};

			if (dirty & /*$$scope*/ 256) {
				notice_changes.$$scope = { dirty, ctx };
			}

			notice.$set(notice_changes);
			if ((!current || dirty & /*product*/ 4) && raw_value !== (raw_value = /*product*/ ctx[2].formattedPrice + "")) div4.innerHTML = raw_value;			const checkbox_changes = {};
			if (dirty & /*isChecked*/ 8) checkbox_changes.checked = /*isChecked*/ ctx[3];

			if (dirty & /*$$scope*/ 256) {
				checkbox_changes.$$scope = { dirty, ctx };
			}

			checkbox.$set(checkbox_changes);

			if (!current || dirty & /*product*/ 4 && !src_url_equal(img.src, img_src_value = /*product*/ ctx[2].tileImageUrl)) {
				attr(img, "src", img_src_value);
			}

			if (!current || dirty & /*product*/ 4 && img_alt_value !== (img_alt_value = /*product*/ ctx[2].title)) {
				attr(img, "alt", img_alt_value);
			}
		},
		i(local) {
			if (current) return;
			transition_in(notice.$$.fragment, local);
			transition_in(checkbox.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(notice.$$.fragment, local);
			transition_out(checkbox.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div9);
			destroy_component(notice);
			destroy_component(checkbox);
		}
	};
}

// (71:4) <Button on:click="{continuePurchase}" disabled="{!isChecked}">
function create_default_slot_2(ctx) {
	let t_1_value = t('Продолжить покупку') + "";
	let t_1;

	return {
		c() {
			t_1 = text(t_1_value);
		},
		m(target, anchor) {
			insert(target, t_1, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t_1);
		}
	};
}

// (70:2) <PopupFooter>
function create_default_slot_1(ctx) {
	let button;
	let current;

	button = new Button({
			props: {
				disabled: !/*isChecked*/ ctx[3],
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	button.$on("click", function () {
		if (is_function(/*continuePurchase*/ ctx[1])) /*continuePurchase*/ ctx[1].apply(this, arguments);
	});

	return {
		c() {
			create_component(button.$$.fragment);
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const button_changes = {};
			if (dirty & /*isChecked*/ 8) button_changes.disabled = !/*isChecked*/ ctx[3];

			if (dirty & /*$$scope*/ 256) {
				button_changes.$$scope = { dirty, ctx };
			}

			button.$set(button_changes);
		},
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
		}
	};
}

// (41:0) <Popup isClosable="{true}" closePopup="{closePopup}">
function create_default_slot(ctx) {
	let popupheader;
	let t0;
	let popupbody;
	let t1;
	let popupfooter;
	let current;

	popupheader = new PopupHeader({
			props: {
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	popupbody = new PopupBody({
			props: {
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	popupfooter = new PopupFooter({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(popupheader.$$.fragment);
			t0 = space();
			create_component(popupbody.$$.fragment);
			t1 = space();
			create_component(popupfooter.$$.fragment);
		},
		m(target, anchor) {
			mount_component(popupheader, target, anchor);
			insert(target, t0, anchor);
			mount_component(popupbody, target, anchor);
			insert(target, t1, anchor);
			mount_component(popupfooter, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const popupheader_changes = {};

			if (dirty & /*$$scope*/ 256) {
				popupheader_changes.$$scope = { dirty, ctx };
			}

			popupheader.$set(popupheader_changes);
			const popupbody_changes = {};

			if (dirty & /*$$scope, product, isChecked*/ 268) {
				popupbody_changes.$$scope = { dirty, ctx };
			}

			popupbody.$set(popupbody_changes);
			const popupfooter_changes = {};

			if (dirty & /*$$scope, isChecked, continuePurchase*/ 266) {
				popupfooter_changes.$$scope = { dirty, ctx };
			}

			popupfooter.$set(popupfooter_changes);
		},
		i(local) {
			if (current) return;
			transition_in(popupheader.$$.fragment, local);
			transition_in(popupbody.$$.fragment, local);
			transition_in(popupfooter.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(popupheader.$$.fragment, local);
			transition_out(popupbody.$$.fragment, local);
			transition_out(popupfooter.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(popupheader, detaching);
			if (detaching) detach(t0);
			destroy_component(popupbody, detaching);
			if (detaching) detach(t1);
			destroy_component(popupfooter, detaching);
		}
	};
}

function create_fragment(ctx) {
	let popup;
	let current;

	popup = new Popup({
			props: {
				isClosable: true,
				closePopup: /*closePopup*/ ctx[0],
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(popup.$$.fragment);
		},
		m(target, anchor) {
			mount_component(popup, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const popup_changes = {};
			if (dirty & /*closePopup*/ 1) popup_changes.closePopup = /*closePopup*/ ctx[0];

			if (dirty & /*$$scope, isChecked, continuePurchase, product*/ 270) {
				popup_changes.$$scope = { dirty, ctx };
			}

			popup.$set(popup_changes);
		},
		i(local) {
			if (current) return;
			transition_in(popup.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(popup.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(popup, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { closePopup } = $$props;
	let { continuePurchase } = $$props;
	let { product } = $$props;
	let { user } = $$props;

	function getAgeRestrictionLocalStorageKey() {
		let id = 'guest';
		const key = 'age_restriction_{id}';

		if (user && user.userId) {
			id = user.userId;
		}

		return key.replace('{id}', id);
	}

	const localStorageKey = getAgeRestrictionLocalStorageKey();
	let isChecked = !!localStorageHelper.get(localStorageKey);

	function onChange(checked) {
		localStorageHelper.set(localStorageKey, checked);
		$$invalidate(3, isChecked = checked);
	}

	onDestroy(() => {
		updateBrowserControlState(false);
	});

	$$self.$$set = $$props => {
		if ('closePopup' in $$props) $$invalidate(0, closePopup = $$props.closePopup);
		if ('continuePurchase' in $$props) $$invalidate(1, continuePurchase = $$props.continuePurchase);
		if ('product' in $$props) $$invalidate(2, product = $$props.product);
		if ('user' in $$props) $$invalidate(5, user = $$props.user);
	};

	return [closePopup, continuePurchase, product, isChecked, onChange, user];
}

class App extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			closePopup: 0,
			continuePurchase: 1,
			product: 2,
			user: 5
		});
	}
}

export { App as default };
//# sourceMappingURL=App.svelte.js.map
